// react-bootstrap imports
// import { useState } from "react"
import Toast from "react-bootstrap/Toast"
import { ToastContainer } from "react-bootstrap"
import Alert from 'react-bootstrap/Alert';

const StdHeaderStyle = "fw-bold text-black"
const StdBodyStyle = "text-black"


export const AlertMessage = ({ show, variant, header, message, onClose }) => 
{
    if (!show) { return <></> }

    return (
        <Alert className="mx-auto w-50" variant={variant} onClose={onClose} dismissible>
            {header && <Alert.Heading>{header}</Alert.Heading>}
            <p>{message}</p>
        </Alert>
    )
}

function NewMyToast({ props, show, close })
{
    if (!show) { return <></> }    

    const {HeaderMessage, BodyMessage, Variation, HeaderStyle, BodyStyle} = props

    return (
        <ToastContainer className="position-fixed top-50 start-50 translate-middle zindex-sticky">
            <Toast bg={Variation} show={show} onClose={close}>
                <Toast.Header className={HeaderStyle}>{HeaderMessage}</Toast.Header>
                <Toast.Body className={BodyStyle}>{BodyMessage}</Toast.Body>
            </Toast>
        </ToastContainer>
    )
}

function MyToast({ props, show, setShow })
{
    if (!show) { return <></> }    

    const {HeaderMessage, BodyMessage, Variation, HeaderStyle, BodyStyle} = props
    let showToast = true

    const toggleShowToast = () => setShow(false)

    return (
        <ToastContainer className="position-fixed top-50 start-50 translate-middle zindex-sticky">
            <Toast bg={Variation} show={showToast} onClose={toggleShowToast}>
                <Toast.Header className={HeaderStyle}>{HeaderMessage}</Toast.Header>
                <Toast.Body className={BodyStyle}>{BodyMessage}</Toast.Body>
            </Toast>
        </ToastContainer>
    )
}

export function CustomToaster({ toaster })
{
    const { HeaderMessage, BodyMessage, Variation, show, close } = toaster
    /*const HeaderMessage = "Seu documento foi gerado com sucesso!"
    const BodyMessage = "O pdf será baixado automaticamente em uma nova aba."
    const Variation = "success"*/
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: StdBodyStyle}

    return <NewMyToast props={ToasterProps} show={show} close={close} />
}

export function SuccessDocumentoGerado({ show, setShow })
{    
    const HeaderMessage = "Seu documento foi gerado com sucesso!"
    const BodyMessage = "O pdf será baixado automaticamente em uma nova aba."
    const Variation = "success"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: "text-white"}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}

export function SuccessDataSaved({ show, setShow, messages })
{
    const HeaderMessage = "Dados salvos com sucesso"
    const BodyMessage = messages !== undefined ? messages.map(msg => msg) : "Tudo certo"
    const Variation = "success"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: "text-white"}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}

export function SuccessDataLoaded({ show, setShow })
{
    const HeaderMessage = "Dados carregados com sucesso"
    const BodyMessage = "Tudo certo"
    const Variation = "success"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: "text-white"}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}

export function WarningNoData({ show, setShow })
{
    const HeaderMessage = "Não há dados a serem carregados."
    const BodyMessage = "É preciso salvar dados deste tipo de documento para carregá-los."
    const Variation = "warning"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: StdBodyStyle}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}

// export function WarningCEPNotFound({ show, setShow })
// {
//     const HeaderMessage = "CEP não encontrado"
//     const BodyMessage = "Certifique-se de que o CEP está digitado corretamente"
//     const Variation = "warning"
//     const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: StdBodyStyle}

//     return <MyToast props={ToasterProps} show={show} setShow={setShow} />
// }

export function WarningIncompleteInput({ show, setShow })
{
    const HeaderMessage = "Faltou preencher algum valor!"
    const BodyMessage = "Certifique-se de preencher todos os campos obrigatórios e usar ponto para números decimais (ex.: 312.15)"
    const Variation = "warning"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: StdBodyStyle}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}

export function WarningInvalidInput({ show, setShow, messages })
{
    if (!messages || !Array.isArray(messages)) { console.log("Erro: as messages precisam ser uma lista de string para usar WarningInvalidInput")}
    
    const HeaderMessage = "Opa! Tem algo errado nos dados informados"
    const BodyMessage = messages.map(msg => msg)
    const Variation = "warning"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: StdBodyStyle}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}

export function ErrorChamadaApiMessage({ apiName, show, setShow })
{
    const HeaderMessage = "Ocorreu um erro ao se comunicar com a aplicação " + apiName
    const BodyMessage = "Por favor, informe o responsável pelo sistema."
    const Variation = "danger"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: StdBodyStyle}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}

export function ErrorSecaoVaziaMessage({ show, setShow })
{
    const HeaderMessage = "Ocorreu um erro ao gerar o formulário: seção vazia."
    const BodyMessage = "Por favor, informe o responsável pelo sistema."
    const Variation = "danger"
    const ToasterProps = {HeaderMessage, BodyMessage, Variation, HeaderStyle: StdHeaderStyle, BodyStyle: StdBodyStyle}

    return <MyToast props={ToasterProps} show={show} setShow={setShow} />
}